import React from 'react';
import { useRecordContext, useTranslate, useFieldValue } from 'react-admin';

import ChipField, { getChipColors } from '../../common/fields/ChipField';


const WorkloadField = ({ source = 'workload', size = 'small', ...props }) => {
    const record = useRecordContext(props);
    const status = useFieldValue({ source });
    const translate = useTranslate();

    if (!record) {
        return null;
    }
    let sx = {};
    switch (status) {
        case 'normal':
            sx = getChipColors('green');
            break;
        case 'high':
            sx = getChipColors('orange');
            break;
        case 'available':
        case 'pending':
            sx = getChipColors('blue');
            break;
        case 'low':
        case 'overloaded':
        case 'blocked':
            sx = getChipColors('red');
            break;
        default:
            break;
    }

    if (!status) {
        return null;
    }

    const statuses = {
        'available': translate('Available'),
        'pending': translate('Pending'),
        'low': translate('Low'),
        'normal': translate('Normal'),
        'high': translate('High'),
        'overloaded': translate('Overloaded'),
        'blocked': translate('Blocked')
    };

    return (
        <ChipField {...props} size={size} source={status} record={statuses} sx={sx} />
    );
};

export default WorkloadField;
